<script setup lang="ts">
import { ref, computed } from 'vue';
import { QInput, useDialogPluginComponent } from 'quasar';

const props = defineProps<{
  companyId: string;
  aFileId: string;
  customerVatNumber?: string;
  errorMessage: string;
  fileName?: string;
}>();

const vatNumber = ref(props?.customerVatNumber || '');
const taxInputDialogRef = ref<QInput | null>(null);

const BAD_REQUEST_EXCEPTION_PREFIX = 'BadRequestException:';

const formattedErrorMessage = computed(() => {
  let message = props.errorMessage;

  if (message.startsWith(BAD_REQUEST_EXCEPTION_PREFIX)) {
    message = message.replace(BAD_REQUEST_EXCEPTION_PREFIX, '').trim();
  }

  return message;
});

const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent();

const onConfirmClick = () => {
  onDialogOK({
    companyId: props.companyId,
    aFileId: props.aFileId,
    customVatNumber: vatNumber.value,
    skipChecks: true,
  });
};

</script>
<template>
  <q-dialog
    ref="dialogRef"
    persistent
    @hide="onDialogHide"
  >
    <q-card
      class="q-pa-md"
      style="min-width: 400px"
    >
      <q-card-section>
        <div class="text-h6">
          VAT Number Validation Issue
        </div>
        <div
          v-if="props.fileName"
          class="text-body2 text-grey-8 q-mt-xs ellipsis"
        >
          {{ props.fileName }}
        </div>
      </q-card-section>

      <q-card-section>
        <q-banner
          rounded
          class="bg-red-5 text-white q-mb-md"
        >
          {{ formattedErrorMessage }}
        </q-banner>
        <p class="q-mb-md text-caption">
          You can edit, delete or proceed with the current customer's VAT number by clicking "Proceed"
        </p>
        <q-input
          ref="taxInputDialogRef"
          v-model="vatNumber"
          label="VAT Number"
          outlined
          class="q-mb-md"
          placeholder="Enter VAT number or leave empty"
          autofocus
          @keydown.stop
        />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          v-close-popup
          flat
          no-caps
          label="Cancel"
          color="primary"
        />
        <q-btn
          flat
          no-caps
          label="Proceed"
          color="primary"
          @click="onConfirmClick"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
